import { appRouter } from "@app/appRouter.ts";
import { OverlaySpinner } from "@app/components/OverlaySpinner.tsx";
import { ThemeProvider } from "@app/components/ThemeProvider.tsx";
import { useAuthStore } from "@app/stores/useAuthStore.ts";
import { queryClient } from "@app/trpc.ts";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode, useEffect, useState } from "react";

export function App() {
  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <RouterProviderWithContext />
        </ThemeProvider>
      </QueryClientProvider>
    </StrictMode>
  );
}

function RouterProviderWithContext() {
  const user = useAuthStore((store) => store.user);
  const load = useAuthStore((store) => store.load);
  const [status, setStatus] = useState<"loading" | "ready" | "error">(
    "loading",
  );

  useEffect(() => {
    let active = true;
    load().then(
      () => {
        if (active) {
          setStatus("ready");
        }
      },
      () => {
        if (active) {
          setStatus("error");
        }
      },
    );
    return () => {
      active = false;
    };
  }, [load]);

  if (status === "loading") {
    return <OverlaySpinner />;
  }

  if (status === "error") {
    return <div>Erro ao carregar o site</div>;
  }

  return (
    <RouterProvider router={appRouter} context={{ isAuthenticated: !!user }} />
  );
}
